import React from 'react'
import { Calendar } from '../../../Components'

const TechnicianCalendar = () => {
  return (
    <Calendar/>
  )
}

export default TechnicianCalendar